export default class FilterDTO {
    constructor(day = null, search = null, stage = null, tag = null) {
        this.day = day;
        this.search = search;
        this.stage = stage;
        this.tag = tag;
    }

    getDay() {
        return this.day;
    }

    getSearch() {
        return this.search;
    }

    getStage() {
        return this.stage;
    }

    getTag() {
        return this.tag;
    }

    isEqualFilter(filterDTO) {
        return this.day === filterDTO.getDay()
            && this.search === filterDTO.getSearch()
            && this.stage === filterDTO.getStage()
            && this.tag === filterDTO.getTag();
    }
}
